class CharCounterClass
{
    init() {
        this.makeContainerForCounters();
        this.updateCurrentCounterValue();
    }

    makeContainerForCounters() {
        document.querySelectorAll('[data-char-counter]:not([data-char-counter-initialized])').forEach(field => {
            if (!isVisible(field)) {
                return;
            }

            if (field.dataset.hasOwnProperty('select2Init')) {
                field = field.nextElementSibling;
            }

            const parent = field.closest('.form-group');

            if (parent) {
                const label = parent.querySelector('label');
                const div = document.createElement('div');
                div.classList.add('d-flex', 'justify-content-between', 'align-items-center');
                div.setAttribute('data-char-counter-container', '');
                div.style.maxWidth = `${field.offsetWidth}px`;
                div.style.width = '100%';
                const counter = document.createElement('div');
                counter.setAttribute('data-char-counter-current-container', '');
                counter.innerHTML = `<span data-char-counter-current>${field.value.length}</span>/${field.dataset.charCounter}`;

                if (label) {
                    div.appendChild(label);
                } else {
                    div.classList.remove('justify-content-between');
                    div.classList.add('justify-content-end');
                }

                div.appendChild(counter);

                parent.insertAdjacentElement('afterbegin', div);
                field.setAttribute('maxlength', field.dataset.charCounter);
                field.setAttribute('data-char-counter-initialized', '');
            }
        });
    }

    updateCurrentCounterValue() {
        $('body').on('keyup', '[data-char-counter][data-char-counter-initialized]', e => {
            const field = e.currentTarget;
            const parent = field.closest('.form-group');

            if (parent) {
                const container = parent.querySelector('[data-char-counter-current-container]');
                const currentCounter = container.querySelector('[data-char-counter-current]');

                if (currentCounter) {
                    currentCounter.innerText = field.value.length;
                }
            }
        });
    }
}

window.CharCounter = new CharCounterClass();
CharCounter.init();
